<template>
    <div class="page">
        <el-form v-if="send" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="">
                <el-input placeholder="菜单名称" v-model="queryForm.menuName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="checkState == 'check'">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="checkState == 'reset'">重置</el-button>
            </el-form-item>
        </el-form>
        <MenuListTable :data="this.data" @send="getData" :checkState="checkState" :queryForm="queryForm" @resetCheckState="resetCheckState" />
    </div>
</template>

<script>
import MenuListTable from '@/components/system/MenuListTableOne.vue';
export default {
    components: {
        MenuListTable
    },
    data() {
        return {
            queryForm: {
                menuName: ''
            },
            data:'',
            send:'',
            checkState: ''
        };
    },
    methods: {
        getData(data){
            this.send = data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {};
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped></style>